import { IonSpinner } from '@ionic/react'
import { observer } from 'mobx-react'
import React from 'react'
import { EmptyPage } from '../../common'
import { PagingSubStore } from '../../store/subStore'
import { InfinityContent } from './InfinityContent'

type PagingContentProps = {
  emptyText?: string
  pagingStore: PagingSubStore<any>
  loadParam?: any
}

export const PagingContent: React.FC<PagingContentProps> = observer(
  ({ pagingStore, loadParam, emptyText, children }) => {
    let appendLoadRendering

    if (pagingStore.isFailed) {
      appendLoadRendering = <EmptyPage icon={'warning'} content={'오류가 발생했습니다. 다시 시도해주세요'} />
    } //
    else if (pagingStore.isLoading) {
      appendLoadRendering = (
        <div style={{ display: 'flex', justifyContent: 'center', height: '117px', alignItems: 'center' }}>
          <IonSpinner color={'medium'} name="dots" />
        </div>
      )
    } //
    else if (pagingStore.isLoaded && pagingStore.list.length < 1) {
      appendLoadRendering = (
        <EmptyPage icon={'alert-circle-outline'} content={emptyText ?? '조회 가능한 내역이 없습니다.'} />
      )
    }
    return (
      <>
        {children}
        <InfinityContent
          onScroll={() => {
            pagingStore.appendOffset()
            pagingStore.load(loadParam)
          }}
          listParams={pagingStore.content}
        />
        {appendLoadRendering}
      </>
    )
  },
)
